import { styled } from 'styled-components';
import { Card } from 'antd';

export const SCard = styled(Card)`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  & .ant-card-body {
    padding: 16px 24px;
    min-width: 560px;
    min-height: 256px;
  }
`;
